<template>
  <div>
    <router-link v-if="to" :to="to" class="button"
      :class="{
        dark: dark,
        big: big,
        outline: outline,
        'super-dark': superDark
      }">
      <icon name="arrow-line-right" class="arrow arrow-line-left" v-if="arrowLeft"></icon>
      <div class="content">
        <slot />
      </div>
      <icon name="arrow-line-right" class="arrow arrow-line-right" v-if="arrow"></icon>
    </router-link>

    <a v-else :href="href" class="button"
      :class="{
        dark: dark,
        big: big,
        outline: outline,
        'super-dark': superDark
      }">
      <icon name="arrow-line-right" class="arrow arrow-line-left" v-if="arrowLeft"></icon>
      <div class="content">
        <slot />
      </div>
      <icon name="arrow-line-right" class="arrow arrow-line-right" v-if="arrow"></icon>
    </a>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  name: 'v-button',
  props: {
    to: String,
    href: {
      type: String,
      default: '#',
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    arrowLeft: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    superDark: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  components: { Icon },
};
</script>

<style lang="scss" scoped>
  .button {
    color: white;
    text-decoration: none;
    text-align: center;
    letter-spacing: 3px;
    text-indent: 3px;
    font-size: 16px;
    padding: 6px 22px;
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    transition: background-color .3s, color .3s;
    position: relative;
    .arrow-line-right {
      transition: right .3s;
      position: absolute;
      right: -25px;
      height: 18px;
      display: flex;
    }
    &.big {
      font-size: 18px;
      padding: 24px 48px;
    }
    &.outline {
      background: transparent;
      border: 1px solid white;
    }
    &.dark {
      color: black;
      border-color: #d7d7d7;
      &:hover {
        background-color: rgba(#d7d7d7, .5);
      }
    }
    &.super-dark {
      padding: 32px 50px;
      color: #a4a8b1;
      font-size: 22px;
      &:hover {
        color: white;
        background-color: rgba(white, .102) !important;
        background-image: linear-gradient(-120deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.15) 100%);
        .arrow {
          /deep/ svg {
            fill: white;
          }
        }
      }
      .arrow {
        position: initial;
        margin: 0 0 0 12px;
        /deep/ svg {
          fill: #a4a8b1;
        }
      }
      .arrow-line-left {
        transform: rotate(-180deg);
        margin: 0 12px 0 0;
      }
    }
    &:hover {
      background-color: rgba(white, .2);
      .arrow-line-right {
        right: -35px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vButton.vue